// Bilingual content dictionary for patrice.studio
// All copy lives here so DE/EN switch stays trivial and editorial copy is editable in one place.

export const t = {
  nav: {
    home: { de: "Start", en: "Home" },
    about: { de: "Über mich", en: "About" },
    projects: { de: "Projekte", en: "Projects" },
    journal: { de: "Journal", en: "Journal" },
    contact: { de: "Kontakt", en: "Contact" },
    booking: { de: "Termin buchen", en: "Book a call" },
    language: { de: "DE / EN", en: "DE / EN" },
  },
  common: {
    scrollHint: { de: "Nach unten scrollen", en: "Scroll" },
    chapter: { de: "Kapitel", en: "Chapter" },
    section: { de: "Sektion", en: "Section" },
    readMore: { de: "Weiterlesen", en: "Read on" },
    backHome: { de: "Zurück zur Startseite", en: "Back to home" },
    soon: { de: "In Entwicklung", en: "In the making" },
    vision: { de: "Vision", en: "Vision" },
    active: { de: "Aktiv & verfügbar", en: "Active & available" },
  },

  home: {
    eyebrow: { de: "PATRICE.STUDIO · EST. 2026", en: "PATRICE.STUDIO · EST. 2026" },
    headline_line_1: { de: "Sichtbarkeit,", en: "Visibility," },
    headline_line_2: { de: "die nicht laut sein muss.", en: "without volume." },
    lede: {
      de: "Ein digitales Atelier für Sichtbarkeit, Storytelling und alles, was zwischen Substanz und Ästhetik liegt. Präsent, ohne etwas beweisen zu müssen.",
      en: "A digital atelier for visibility, storytelling and everything in between substance and aesthetics. Present, without having to prove anything.",
    },
    cta_primary: { de: "Projekte ansehen", en: "Explore projects" },
    cta_ghost: { de: "Hallo sagen", en: "Say hello" },

    trust_strip: {
      label: { de: "Wie hier gearbeitet wird", en: "How the studio works" },
      items: [
        { de: "Klar", en: "Clear" },
        { de: "Sichtbar", en: "Visible" },
        { de: "Authentisch", en: "Authentic" },
        { de: "Präzise", en: "Precise" },
        { de: "Kreativ", en: "Creative" },
      ],
    },

    manifesto: {
      label: { de: "Manifest", en: "Manifesto" },
      title: {
        de: "Eine Marke ist keine Lautstärke. Sie ist eine Atmosphäre.",
        en: "A brand isn’t a volume. It is an atmosphere.",
      },
      body: {
        de: "patrice.studio ist die Heimat meiner Arbeit. Hier leben Projekte, die Substanz mit Schönheit verbinden — von professionellem Bewertungsmanagement über Webseiten und Fotografie bis hin zu Musik und digitalen Produkten. Jedes davon ist ein eigener Raum in einem Haus, das langsam wächst.",
        en: "patrice.studio is where my work lives. Projects with quiet substance and serious beauty — from reputation management to websites, photography, music and digital products. Each one is its own room in a slowly growing house.",
      },
    },

    pillars: {
      title: { de: "Was die Marke trägt", en: "What carries this brand" },
      items: [
        { de: "Sichtbarkeit", en: "Visibility" },
        { de: "Storytelling", en: "Storytelling" },
        { de: "Authentizität", en: "Authenticity" },
        { de: "Vertrauen", en: "Trust" },
        { de: "Eleganz", en: "Elegance" },
        { de: "KI-Unterstützung", en: "AI-supported craft" },
        { de: "Menschliche Nähe", en: "Human warmth" },
        { de: "Hochwertige Präsenz", en: "Refined presence" },
      ],
    },

    universe: {
      eyebrow: { de: "Projekt-Universum", en: "Project universe" },
      title: {
        de: "Die Arbeit, die ich für andere tue.",
        en: "The work I do for others.",
      },
      lede: {
        de: "Jedes Projekt ist ein Gespräch — zwischen dem, was du brauchst, und dem, was ich kann. Eine Basis, die steht — und mit jedem Projekt wächst.",
        en: "Every project is a conversation — between what you need and what I can do. A foundation that stands — and grows with each project.",
      },
    },

    erleben: {
      eyebrow: { de: "Erlebnisräume", en: "Inner rooms" },
      title: {
        de: "Die Welt, in der ich selbst lebe.",
        en: "The world I live in myself.",
      },
      lede: {
        de: "Fünf Räume, eine Handschrift. Manche sind schon eingerichtet, manche werden gerade möbliert, andere sind im Entstehen — existieren noch als Skizze. Sie erscheinen, wenn ihre Zeit gekommen ist — wie eine Pfingstrose, die nicht das ganze Jahr blüht und gerade deshalb so besonders ist.",
        en: "Five rooms, one signature. Some are already furnished, some are still being arranged, others are in the making — still living as a sketch. They appear when their time has come — like a peony that does not bloom the whole year and is precious exactly for that reason.",
      },
      footer_line: {
        de: "Mehr wartet in den Erlebnisräumen. Fotografie, Kunst, Musik, Atelier & Kreatives — fünf Räume, die du im Home-Studio betreten kannst.",
        en: "More awaits in the inner rooms. Photography, art, music, atelier & creative — five rooms you can step into in the home studio.",
      },
    },

    about_teaser: {
      eyebrow: { de: "Über mich", en: "About" },
      title: {
        de: "Ich bin Patrice. Und das reicht mir vollkommen.",
        en: "I am Patrice. And that is more than enough.",
      },
      body: {
        de: "Irgendwann habe ich aufgehört zu fragen, was gut aussieht – und angefangen zu fragen, was mich lebendig macht. Daraus wurde patrice.studio.",
        en: "At some point I stopped asking what looks good — and started asking what makes me alive. patrice.studio was born from that question.",
      },
      cta: { de: "Meine Geschichte lesen", en: "Read my story" },
    },

    footer_cta: {
      whisper: { de: "Lass uns sprechen.", en: "Let’s talk." },
      headline: {
        de: "Wenn etwas in dir leise „ja“ sagt — folge dem.",
        en: "If something in you quietly says “yes” — follow it.",
      },
      cta: { de: "Anfrage schreiben", en: "Write to me" },
    },
  },

  about: {
    eyebrow: { de: "Über mich", en: "About" },
    title_line_1: { de: "Ich bin", en: "I am" },
    title_line_2: { de: "Patrice.", en: "Patrice." },
    intro: {
      de: "Eine erzählerische Reise – über das, was war, was sich verändert hat und was entstanden ist.",
      en: "A narrative journey — about what was, what changed and what came into being.",
    },
    chapter1_label: { de: "I. Wer ich nicht mehr sein muss", en: "I. Who I no longer need to be" },
    chapter1: {
      de: "Nicht die Personalleiterin. Nicht die Storemanagerin. Nicht die Frau mit dem makellosen Lebenslauf, den ich jahrelang gehegt und gepflegt habe wie einen englischen Rasen – damit ja keine Lücke entsteht und alles immer höher, schneller, weiter geht.\n\nIch bin Patrice.\nUnd das reicht mir vollkommen.",
      en: "Not the head of HR. Not the store manager. Not the woman with the immaculate résumé I tended for years like an English lawn — so no gap would ever appear and everything would always be higher, faster, further.\n\nI am Patrice.\nAnd that is more than enough for me.",
    },
    chapter2_label: { de: "II. Die Frage, die alles verändert hat", en: "II. The question that changed everything" },
    chapter2: {
      de: "Irgendwann habe ich aufgehört zu fragen: Was sieht gut aus?\n\nUnd angefangen zu fragen: Was macht mich lebendig & glücklich?",
      en: "At some point I stopped asking: what looks good?\n\nAnd started asking: what makes me alive & happy?",
    },
    chapter3_label: { de: "III. Drei Inseln. Sechs Monate. Ein Leben.", en: "III. Three islands. Six months. One life." },
    chapter3: {
      de: "Die Antwort kam in Form eines sechsmonatigen Sabbaticals – Bali, Neuseeland, Rarotonga.\n\nAbenteuer pur. Freiheit pur. Die beste Zeit meines Lebens – und der klarste Beweis dafür, dass es auch anders geht.",
      en: "The answer arrived as a six-month sabbatical — Bali, New Zealand, Rarotonga.\n\nPure adventure. Pure freedom. The best time of my life — and the clearest proof that things can be different.",
    },
    chapter4_label: { de: "IV. Heute", en: "IV. Today" },
    chapter4: {
      de: "Heute arbeite ich digital. Von dort, wo ich gerade bin. Mit vollem Herzen.",
      en: "Today I work digitally. From wherever I am. With my whole heart.",
    },
    closing_signature: {
      de: "— Patrice Schreiter",
      en: "— Patrice Schreiter",
    },
    cta: { de: "In Kontakt treten", en: "Get in touch" },
  },

  projects: {
    eyebrow: { de: "Projekte", en: "Projects" },
    title: {
      de: "Hier lebt die Arbeit.",
      en: "Here the work lives.",
    },
    lede: {
      de: "Sichtbar Gut Bewertet ist die Heimat meiner Dienstleistungen — professionell, durchdacht, mit echter Wirkung. Jedes Projekt gehört zur selben Marke — mit eigener Persönlichkeit innerhalb derselben Atmosphäre.",
      en: "Sichtbar Gut Bewertet is the home of my services — professional, considered, with real impact. Every project belongs to the same brand — with its own character inside the same atmosphere.",
    },
    rooms: {
      active: {
        label: { de: "01 · Aktiv & verfügbar", en: "01 · Active & available" },
        items: [
          {
            id: "sgb",
            name: { de: "Online-Bewertungsmanagement", en: "Online review management" },
            sub: { de: "Google & Trustpilot", en: "Google & Trustpilot" },
            body: {
              de: "Professionelles Bewertungsmanagement für Unternehmen – strukturiert, dokumentiert, nachvollziehbar. Lebt unter eigener Marke: Sichtbar Gut Bewertet.",
              en: "Professional review management for companies — structured, documented, traceable. Living under its own brand: Sichtbar Gut Bewertet.",
            },
            link: "/sgb",
            external: false,
          },
          {
            id: "social",
            name: { de: "Social Media & DSA", en: "Social media & DSA" },
            sub: { de: "Unterstützung bei gesperrten Accounts", en: "Support with restricted accounts" },
            body: {
              de: "Begleitung durch das offizielle DSA-Verfahren bei TikTok, Instagram & Co. — diskret, strukturiert, dokumentiert.",
              en: "Guidance through the official DSA process for TikTok, Instagram & others — discreet, structured, documented.",
            },
          },
          {
            id: "web",
            name: { de: "Webseiten & Hosting", en: "Websites & hosting" },
            sub: { de: "Design, Aufbau, Pflege", en: "Design, build, care" },
            body: {
              de: "Moderne Webseiten mit klarer Struktur, starker Wirkung und einer Außenwirkung, die zur Marke passt. Vom Konzept bis zum Launch.",
              en: "Modern websites with clear structure, strong presence and an outward feel that matches the brand. From concept to launch.",
            },
          },
          {
            id: "photo",
            name: { de: "Fotografie", en: "Photography" },
            sub: { de: "Eigene Bildwelt · Luminar", en: "An original visual library · Luminar" },
            body: {
              de: "Eine eigene Bildwelt aus Pflanzen, Blüten und Atmosphären – fotografiert und veredelt mit Luminar. Grundlage der Markenfarben.",
              en: "An original library of plants, blooms and atmospheres — photographed and refined in Luminar. The source of the brand’s color palette.",
            },
          },
        ],
      },
      soon: {
        label: { de: "02 · In Entwicklung", en: "02 · In the making" },
        items: [
          {
            id: "nfc",
            name: { de: "NFC-Aufsteller", en: "NFC stands" },
            body: {
              de: "Eine physische Brücke zwischen Offline und Online: elegante Aufsteller, die mit einer Berührung Sichtbarkeit erzeugen.",
              en: "A physical bridge between offline and online — elegant stands that create visibility with a single touch.",
            },
          },
          {
            id: "music",
            name: { de: "Musikprojekte", en: "Music projects" },
            body: {
              de: "Produktion über Suno, Veröffentlichung via Distrokid auf Spotify, Apple Music und Amazon. Ein eigener Klangraum für die Marke.",
              en: "Produced with Suno, released through Distrokid on Spotify, Apple Music and Amazon. A sound space of its own.",
            },
          },
          {
            id: "digital",
            name: { de: "Digitale Produkte", en: "Digital products" },
            body: {
              de: "Prints, Presets, Moodboards und Brand Kits — kleine, hochwertige Werke aus dem Studio, für andere Kreative.",
              en: "Prints, presets, moodboards and brand kits — small, refined works from the studio, made for other creatives.",
            },
          },
        ],
      },
      vision: {
        label: { de: "03 · Vision", en: "03 · Vision" },
        items: [
          {
            id: "etsy",
            name: { de: "Etsy Shop", en: "Etsy shop" },
            body: {
              de: "Ein Ort für digitale und physische Produkte: Fotodrucke, Farbpaletten, kreative Assets. Langfristig gedacht, nicht eilig.",
              en: "A place for digital and physical products: photo prints, color palettes, creative assets. Built for the long run, never rushed.",
            },
          },
        ],
      },
    },
    closing: {
      title: {
        de: "Ein wachsendes Ökosystem.",
        en: "A growing ecosystem.",
      },
      body: {
        de: "Diese Räume entwickeln sich. Neue kommen dazu. Manche werden ganz still. Das ist Teil der Marke.",
        en: "These rooms keep evolving. New ones arrive. Some go quiet. That, too, is part of the brand.",
      },
    },
  },

  journal: {
    eyebrow: { de: "Journal · in Vorbereitung", en: "Journal · coming soon" },
    title: {
      de: "Worte folgen, sobald die Tinte trocken ist.",
      en: "Words will follow once the ink has dried.",
    },
    body: {
      de: "Hier entsteht das Magazin von patrice.studio — Notizen, Storys, kleine Essays über Sichtbarkeit, Marken und das Leben dazwischen.",
      en: "This is where the patrice.studio magazine takes shape — notes, stories and small essays on visibility, brands and the life in between.",
    },
    notify: { de: "Benachrichtige mich beim Start", en: "Notify me at launch" },
  },

  contact: {
    eyebrow: { de: "Kontakt", en: "Contact" },
    title: { de: "Lass uns sprechen.", en: "Let’s talk." },
    lede: {
      de: "Eine ehrliche Nachricht ist mir lieber als der perfekte erste Satz. Schreib einfach.",
      en: "An honest message means more to me than the perfect opening line. Just write.",
    },
    form: {
      name: { de: "Dein Name", en: "Your name" },
      email: { de: "E-Mail", en: "Email" },
      topic: { de: "Thema (optional)", en: "Topic (optional)" },
      message: { de: "Deine Nachricht", en: "Your message" },
      submit: { de: "Nachricht senden", en: "Send message" },
      placeholder_name: { de: "Wer schreibt mir?", en: "Who am I speaking to?" },
      placeholder_email: { de: "deine@adresse.de", en: "you@somewhere.com" },
      placeholder_topic: { de: "Projekt · Frage · Kollaboration …", en: "Project · question · collaboration …" },
      placeholder_message: {
        de: "Erzähl mir, was dich gerade beschäftigt.",
        en: "Tell me what’s on your mind.",
      },
      success: {
        de: "Danke. Deine Nachricht ist hier — ich melde mich.",
        en: "Thank you. Your message is here — I’ll be in touch.",
      },
      error: {
        de: "Etwas ist schiefgelaufen. Bitte versuche es in einem Moment erneut.",
        en: "Something went wrong. Please try again in a moment.",
      },
    },
    booking_block: {
      label: { de: "Termin", en: "Booking" },
      title: {
        de: "Lieber direkt? Buche ein kurzes Kennenlernen.",
        en: "Prefer a call? Book a short introduction.",
      },
      body: {
        de: "30 Minuten, kostenfrei, ohne Verpflichtung. Wir schauen, ob wir zusammenpassen.",
        en: "Thirty minutes, free of charge, with no obligation. We see if we’re a match.",
      },
      cta: { de: "Termin anfragen", en: "Request a call" },
    },
    booking_form: {
      title: { de: "Termin anfragen", en: "Request a booking" },
      project_type: { de: "Worum geht es?", en: "What is it about?" },
      project_options: [
        { de: "Webseite", en: "Website" },
        { de: "Bewertungsmanagement", en: "Review management" },
        { de: "Social Media · DSA", en: "Social media · DSA" },
        { de: "Markenentwicklung", en: "Brand development" },
        { de: "Etwas anderes", en: "Something else" },
      ],
      phone: { de: "Telefon (optional)", en: "Phone (optional)" },
      date: { de: "Wunschtermin", en: "Preferred date" },
      notes: { de: "Notizen", en: "Notes" },
      submit: { de: "Anfrage senden", en: "Send request" },
      success: { de: "Danke. Deine Anfrage ist eingegangen.", en: "Thank you. Your request has been received." },
    },
    elsewhere: { de: "Sonst zu finden", en: "Also here" },
    socials: [
      { label: "Instagram", handle: "@patrice.digital", href: "https://instagram.com/patrice.digital" },
      { label: "Sichtbar Gut Bewertet", handle: "sichtbargutbewertet.de", href: "https://www.sichtbargutbewertet.de" },
    ],
  },

  footer: {
    columns: {
      studio: { de: "Studio", en: "Studio" },
      universe: { de: "Universum", en: "Universe" },
      whisper: { de: "Im Stillen", en: "Quietly" },
    },
    newsletter: {
      label: { de: "Brief von Patrice", en: "Letter from Patrice" },
      blurb: {
        de: "Gedanken aus dem Universum. Kein Newsletter. Eher Post aus dem Atelier.",
        en: "Thoughts from the universe. Not a newsletter. More like mail from the atelier.",
      },
      placeholder: { de: "deine@adresse.de", en: "you@somewhere.com" },
      submit: { de: "Eintragen", en: "Subscribe" },
      success: { de: "Eingetragen. Danke.", en: "Subscribed. Thank you." },
      already: { de: "Diese Adresse ist bereits eingetragen.", en: "This address is already subscribed." },
    },
    legal: {
      imprint: { de: "Impressum", en: "Imprint" },
      privacy: { de: "Datenschutz", en: "Privacy" },
      terms: { de: "AGB", en: "Terms" },
      copyright: {
        de: "© 2026 patrice.studio · Patrice Schreiter",
        en: "© 2026 patrice.studio · Patrice Schreiter",
      },
    },
  },
};
